import { createContext, useContext } from "react";
import socketIOClient from "socket.io-client";

import Player from "../../Types/Player";

interface PlayersContextProps {
  players: { [socketId: string]: Player };
  getSocketName: (socketId: string) => string | undefined;
}

export const PlayersContext = createContext<PlayersContextProps>({
  players: {},
  getSocketName: () => "",
});
export const usePlayersContext = () => useContext(PlayersContext);
const socket = socketIOClient({ path: window.REACT_APP_SOCKET_URL });

export const SocketContext = createContext(socket);
export const useSocketContext = () => useContext(SocketContext);
